<template>
  <span :style="setInstallationStatusColor()">
    {{ translateInstallationStatus() }}
  </span>
</template>

<script>
import { INSTALLATION_STATUS } from '../../modules/installation/constants';
import { setPanoramaInvoiceInstallationStatusColor } from '../../modules/panorama/utils';

export default {
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    translateInstallationStatus() {
      const translatedStatus = INSTALLATION_STATUS[this.value];
      return translatedStatus.length > 10
        ? `${translatedStatus.substring(0, 10)}...`
        : translatedStatus;
    },
    setInstallationStatusColor() {
      return setPanoramaInvoiceInstallationStatusColor(this.value);
    },
  },
};
</script>
